import styled from "styled-components"
import { COLOR, HOVER_SHADOW } from "styles/style-constants"

const Card = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: ${HOVER_SHADOW};
  color: ${COLOR.textBlack};
  background-color: ${COLOR.white};

  ${(props) => props.color && `color: ${props.color};`}
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.radius && `border-radius: ${props.radius};`}
  ${(props) => props.border && `border: ${props.border};`}
  ${(props) => props.boxShadow && `box-shadow: ${props.boxShadow};`}
  ${(props) => props.mt && `margin-top: ${props.mt}px;`}
  ${(props) => props.mb && `margin-bottom: ${props.mb}px;`}
  ${(props) => props.mr && `margin-right: ${props.mr}px;`}
  ${(props) => props.ml && `margin-left: ${props.ml}px;`}
  ${(props) => props.pt && `padding-top: ${props.pt}px;`}
  ${(props) => props.pb && `padding-bottom: ${props.pb}px;`}
  ${(props) => props.pr && `padding-right: ${props.pr}px;`}
  ${(props) => props.pl && `padding-left: ${props.pl}px;`}
  ${(props) => props.padding && `padding: ${props.padding};`}
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight};`}
  ${(props) => props.minWidth && `max-width: ${props.minWidth};`}
  ${(props) => props.minHeight && `max-height: ${props.minHeight};`}
  
  @media (max-width: 520px) {
    ${(props) => props.mMargin && `margin: ${props.mMargin};`}
    ${(props) => props.mWidth && `width: ${props.mWidth};`}
    ${(props) => props.mHeight && `height: ${props.mHeight};`}
    ${(props) => props.mPadding && `padding: ${props.mPadding};`}
    ${(props) => props.mMaxWidth && `max-width: ${props.mMaxWidth};`}
    ${(props) => props.mMaxHeight && `max-height: ${props.mMaxHeight};`}
    ${(props) => props.mMinWidth && `min-width: ${props.mMinWidth};`}
    ${(props) => props.mMinHeight && `min-height: ${props.mMinHeight};`}
    ${(props) => props.mNoShadow && `box-shadow: none;`}
    ${(props) => props.mBorder && `border: ${props.mBorder};`}
    @media (max-width: 373px) {
      ${(props) => props.mUnsetHeight && `height: unset`}
    }
  }

`

export default Card
